import { render, staticRenderFns } from "./AddressesPage.vue?vue&type=template&id=c1f9dc34&scoped=true"
import script from "./AddressesPage.vue?vue&type=script&lang=js"
export * from "./AddressesPage.vue?vue&type=script&lang=js"
import style0 from "./AddressesPage.vue?vue&type=style&index=0&id=c1f9dc34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1f9dc34",
  null
  
)

export default component.exports